module.exports = {"150622001":"兴隆街道","150622002":"迎泽街道","150622003":"蓝天街道","150622004":"友谊街道","150622100":"薛家湾镇","150622101":"沙圪堵镇","150622102":"大路镇","150622103":"纳日松镇","150622104":"龙口镇","150622105":"准格尔召镇","150622106":"魏家峁镇","150622200":"暖水乡","150622201":"十二连城乡","150622202":"布尔陶亥苏木","150622400":"准格尔经济开发区","150622401":"大路煤化工基地"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150622.json
// module id = 527
// module chunks = 0